<template>
    <div class="container">
        <h2>
            Submittal Information
        </h2>

        <p class="info">Notes will be displayed near the submittal stamp on each product information page.</p>
    </div>
</template>

<script>
    export default {
        props: ['project']
    }
</script>